<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="hasMissingCreativeSizes"
    v-tooltip.right="{ html: true, content }"
    class="mr-2">
    <icon-creative />
    <!--    <div v-sanitize-html="content"></div>-->
  </div>
</template>

<script type="text/babel">
  import { IconCreative } from '@/common/icons/monochrome';
  import { generateUUID } from '@/globals';
  import i18n from '@/vueI18n';

  export default {
    components: { IconCreative },
    props: {
      missingCreativeSizes: {
        type: Array,
      },
    },
    data() {
      return {
        id: generateUUID(),
      };
    },
    computed: {
      hasMissingCreativeSizes() {
        return this.missingCreativeSizes?.flat().length > 0;
      },
      missingCreativeSizesFormatted() {
        let tooltip = `<span>${i18n.global.t('messages.missingCreativeFileSizes')}:</span><ul style="text-align: left;padding-left: 20px;" class="missing-creative-file-sizes">`;
        const sorted = [...this.missingCreativeSizes.flat()].sort(
          (a, b) =>
            (a.dimensions !== undefined ? a.dimensions[0] : a[0]) -
            (b.dimensions !== undefined ? b.dimensions[0] : b[0]),
        );
        const grouped = sorted.reduce((mem, x) => {
          const mutatedMem = { ...mem };
          const key = `${x.dimensions != null ? x.dimensions[0] : x[0]} x ${x.dimensions != null ? x.dimensions[1] : x[1]}`;
          if (mutatedMem[key]) {
            mutatedMem[key].push(x);
          } else {
            mutatedMem[key] = [x];
          }
          return mutatedMem;
        }, {});
        Object.keys(grouped).forEach((key) => {
          let screenInfo = '';
          const screenCount = grouped[key].reduce((mem, x) => mem + (x.unit_ids != null ? x.unit_ids.length : 0), 0);
          if (screenCount > 0) {
            screenInfo = ` (${screenCount} ${i18n.global.t('names.screen', screenCount)})`;
          }
          tooltip += `<li>${key}${screenInfo}</li>`;
        });
        tooltip += '</ul>';
        return tooltip;
      },
      content() {
        return this.missingCreativeSizesFormatted;
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  div {
    display: inline-block;

    svg {
      fill: var(--error);
      stroke: var(--error);
    }
  }

  .table {
    div {
      display: flex;
      align-items: center;
      svg {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
  }
</style>
